import React from 'react'
import CategoryInput from 'sprockets_react/job_wizards/components/CategoryInput'
import LocationInput from 'sprockets_react/components/LocationInput'
import { Job, JobWizard, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

const GetQuotesV2 = React.createClass({
  getInitialState: function () {
    return this.getCategorySuburb();
  },

  componentDidMount: function () {
    Job.Store.addChangeListener(this.updateState);
  },

  componentWillUnmount: function () {
    Job.Store.removeChangeListener(this.updateState);
  },

  getCategorySuburb: function () {
    return $.extend(Job.Store.getCategory(), Job.Store.getSuburb());
  },

  updateState: function (data) {
    this.setState(this.getCategorySuburb());
  },

  handleSelectedCategory: function (event, selected) {
    event.preventDefault();
    Job.Actions.updateCategory(selected.item);
    Job.Actions.updateSubCategory(selected.item, "add");
    Job.Actions.updateKeyword(selected.item.keyword);
  },

  handleCategoryOnChange: function (event) {
    Job.Actions.updateSubCategory(
      { id: Job.Data.category_id, values: Job.Data.category },
      "remove"
    );
    Job.Actions.updateCategory({ id: 0, value: event.target.value });
    Job.Actions.updateKeyword(null);
  },

  handleAutocompleteSelection: function (event, response) {
    Job.Actions.updateLocation({
      id: response.item.id,
      value: response.item.value,
    });
  },

  handleLocationChange: function (event) {
    Job.Actions.updateLocation({ id: 0, value: event.target.value });
  },

  handleClick: function () {
    var showJobWizardModal = () => {
      if (jobLocationAutocompleteSelected() && categoryValuePresent()) {
        if (window.mobilecheck()) {
          advanceMobileWizardToNextStep();
        } else {
          advanceWizardToNextStep();
        }
      }

      $("#job-modal").modal(
        { keyboard: false, backdrop: "static" },
        { cta: this.props.cta }
      );

      function advanceWizardToNextStep() {
        let steps = JobWizard.Steps;
        let details = JobWizard.Details;
        let detailsStepIndex = details.detailsStepIndex(steps);
        let nextStep = steps[detailsStepIndex + 1];

        if (
          nextStep === JobWizard.SubCategory &&
          details.hasSubcategory()
        ) {
          JobWizard.Emitter.emit(
            "job:wizard:advanceToStep",
            JobWizard.Description
          );
        } else {
          JobWizard.Emitter.emit("job:wizard:advanceToNextStep");
        }
      }

      function advanceMobileWizardToNextStep() {
        JobWizardMobile.Emitter.emit(
          "job:wizard:advanceToStep",
          JobWizardMobile.SelectCategory
        );
      }

      function jobLocationAutocompleteSelected() {
        return Job.Data.suburb_id !== 0;
      }

      function categoryValuePresent() {
        return Job.Data.category.trim() !== "";
      }
    };

    showJobWizardModal();
  },

  selectExactMatchForSubcategory: function (callback) {
    $.ajax(
      SS.API.V3.subCategoriesGet({ "filter[q]": this.searchTerm(), "filter[prefer_keywords]": "1" })
    ).done((response) => {
      const keyword = response.meta.keyword;

      if (keyword) {
        let category = {
          id: keyword.subcategoryID,
          value: keyword.subcategoryName,
        };
        Job.Actions.updateKeyword(keyword.value);
        Job.Actions.updateCategory(category);
        Job.Actions.updateSubCategory(category, "add");
        JobWizard.Emitter.emit("job:wizard:categorySelected", null, {
          item: category,
        });
      } else {
        for (let item of response.data) {
          if (this.searchTerm().toLowerCase() == item.attributes.name.toLowerCase()) {
            let category = { id: parseInt(item.id, 10), value: item.attributes.name };
            Job.Actions.updateCategory(category);
            Job.Actions.updateSubCategory(category, "add");
            JobWizard.Emitter.emit(
              "job:wizard:categorySelected",
              null,
              { item: category }
            );
          }
        }
      }

      callback();
    });
  },

  searchTerm: function () {
    return $('input[name="category"]').val();
  },

  render: function () {
    return (
      <div className="grid grid-cols-12">
        <div className="hidden sm:block sm:col-span-5 rounded-l-lg home-text-area pb10 category-input-container">
          <div className="text-center">
            <CategoryInput
              category={this.state.keyword || this.state.category}
              handleSelectedCategory={this.handleSelectedCategory}
              handleCategoryChange={this.handleCategoryOnChange}
              preferKeywords="1"
              inputClass="w-full rounded-l-lg border-0 border-r border-old-gray-tones-400 py-5 md:px-5 2xl:px-7 placeholder-gray-tones-200"
              placeholder={`e.g. Tiler, Cleaner, Electrician`}
              guId={SS.utils.generateGuid()}
            />
          </div>
        </div>
        <div className="hidden sm:block sm:col-span-5 home-text-area pb10 location-input-container">
          <div className="text-center">
            <LocationInput
              suburb={this.state.suburb}
              handleAutocompleteSelection={this.handleAutocompleteSelection}
              handleLocationChange={this.handleLocationChange}
              inputClass="w-full border-0 py-5 md:px-5 2xl:px-7 placeholder-gray-tones-200"
              placeholder={`Enter Postcode or Suburb`}
              guId={SS.utils.generateGuid()}
            />
          </div>
        </div>

        <button
          className={`col-span-12 sm:col-span-2 sm:w-full p-4 sm:py-0 px-8 sm:justify-self-start justify-self-center submit-container btn btn-main submit-button text-center bg-primary text-white lg:text-sm text-lg font-semibold hover:bg-green-600 rounded-lg sm:rounded-l-none`}
          onClick={this.handleClick}
        >
          Get Quotes
        </button>
      </div>
    );
  },
});

export default GetQuotesV2
